import { Injectable } from '@angular/core';
import { LegDetailStatus } from 'src/app/@shared/constants/Constant';
import { ConfirmationMsg } from 'src/app/@shared/constants/confirmation-msg.constant';
import { ISortBySRColumn } from 'src/app/model/Vendor.model';
import { ISRStatusModel } from 'src/app/model/report.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdatedSRService {
  public isUpdateStatus: boolean = true;
  public redirectionFilter = new BehaviorSubject<any>(null);
  public column = {
    isCustomerCol: false,
    isTypeCol: false,
    isOriginCol: false,
    isDestinationCol: false,
    isStatusCol: false,
    isPlannedCol: false,
    isActualCol: false,
    //Member Page Sort by feature
    isNameCol: false,
    isPhoneCol: false,
    isEmailCol: false,
    isDesignationCol: false,
    //Vehicle Management Page Sort by feature
    isVehicleNameCol: false,
    isYearCol: false,
    isMakeCol: false,
    isModelCol: false,
    isPlateNumberCol: false,
    isInsuranceExpDateCol: false,
    isRegistrationExpDateCol: false,
    isLocationCol: false,
    //Notes and Files Page Sort by feature
    isDateTimeCol: false,
    isByCol: false,
    isCategoryCol: false,
    isNoteCol: false,
    isFileNameCol: false,
  };
  public prevStatus = {
    isNotStarted: false,
    isEnroute: false,
    isOnStandby: false,
    isRepositioning: false,
    isInPosition: false,
    isOnScene: false,
    isOnBoard: false,
    isPickedUp: false,
    isWheelsUp: false,
    isLanded: false,
    isDroppedOff: false,
    isDriverDone: false,
    isJobDone: false,
  };
  public currStatus = {
    isNotStarted: false,
    isEnroute: false,
    isOnStandby: false,
    isRepositioning: false,
    isInPosition: false,
    isOnScene: false,
    isOnBoard: false,
    isPickedUp: false,
    isWheelsUp: false,
    isLanded: false,
    isDroppedOff: false,
    isDriverDone: false,
    isJobDone: false,
  };

  public sortByColumn: ISortBySRColumn = {
    customer: false,
    type: false,
    origin: false,
    destination: false,
    status: false,
    planned: false,
    actual: false,
    //Member Page Sort by feature
    name: false,
    phone: false,
    email: false,
    designation: false,
    //Vehicle Management Page Sort by feature
    vehicleName: false,
    year: false,
    make: false,
    model: false,
    plateNumber: false,
    insuranceExpDate: false,
    registrationExpDate: false,
    location: false,
    //Notes and Files Page Sort by feature
    createdOn: false,
    createdBy: false,
    category: false,
    description: false,
    fileName: false,
  };

  constructor() {}

  sorting(columnName) {
    this.column = {
      isCustomerCol: columnName == 'customer',
      isTypeCol: columnName == 'type',
      isOriginCol: columnName == 'origin',
      isDestinationCol: columnName == 'destination',
      isStatusCol: columnName == 'status',
      isPlannedCol: columnName == 'planned',
      isActualCol: columnName == 'actual',
      //Member Page Sort by feature
      isNameCol: columnName == 'name',
      isPhoneCol: columnName == 'phone',
      isEmailCol: columnName == 'email',
      isDesignationCol: columnName == 'designation',
      //Vehicle Management Page Sort by feature
      isVehicleNameCol: columnName == 'vehicleName',
      isYearCol: columnName == 'year',
      isMakeCol: columnName == 'make',
      isModelCol: columnName == 'model',
      isPlateNumberCol: columnName == 'plateNumber',
      isInsuranceExpDateCol: columnName == 'insuranceExpDate',
      isRegistrationExpDateCol: columnName == 'registrationExpDate',
      isLocationCol: columnName == 'location',
      //Notes and Files Page Sort by feature
      isDateTimeCol: columnName == 'createdOn',
      isByCol: columnName == 'createdBy',
      isCategoryCol: columnName == 'category',
      isNoteCol: columnName == 'description',
      isFileNameCol: columnName == 'fileName',
    };

    switch (true) {
      case this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: !this.sortByColumn.customer,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: !this.sortByColumn.type,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: !this.sortByColumn.origin,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: !this.sortByColumn.destination,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: !this.sortByColumn.status,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };

        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: !this.sortByColumn.planned,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: !this.sortByColumn.actual,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: !this.sortByColumn.name,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: !this.sortByColumn.phone,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: !this.sortByColumn.email,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: !this.sortByColumn.designation,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: !this.sortByColumn.vehicleName,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: !this.sortByColumn.year,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: !this.sortByColumn.make,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: !this.sortByColumn.model,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: !this.sortByColumn.plateNumber,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: !this.sortByColumn.insuranceExpDate,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: !this.sortByColumn.registrationExpDate,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: !this.sortByColumn.location,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: !this.sortByColumn.createdOn,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: !this.sortByColumn.createdBy,
          category: false,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: !this.sortByColumn.category,
          description: false,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        this.column.isNoteCol &&
        !this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: !this.sortByColumn.description,
          fileName: false,
        };
        break;
      case !this.column.isCustomerCol &&
        !this.column.isTypeCol &&
        !this.column.isOriginCol &&
        !this.column.isDestinationCol &&
        !this.column.isStatusCol &&
        !this.column.isPlannedCol &&
        !this.column.isActualCol &&
        !this.column.isNameCol &&
        !this.column.isPhoneCol &&
        !this.column.isEmailCol &&
        !this.column.isDesignationCol &&
        !this.column.isVehicleNameCol &&
        !this.column.isYearCol &&
        !this.column.isMakeCol &&
        !this.column.isModelCol &&
        !this.column.isPlateNumberCol &&
        !this.column.isInsuranceExpDateCol &&
        !this.column.isRegistrationExpDateCol &&
        !this.column.isLocationCol &&
        !this.column.isDateTimeCol &&
        !this.column.isByCol &&
        !this.column.isCategoryCol &&
        !this.column.isNoteCol &&
        this.column.isFileNameCol:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: !this.sortByColumn.fileName,
        };
        break;
      default:
        this.sortByColumn = {
          customer: false,
          type: false,
          origin: false,
          destination: false,
          status: false,
          planned: false,
          actual: false,
          //Member Page Sort by feature
          name: false,
          phone: false,
          email: false,
          designation: false,
          //Vehicle Management Page Sort by feature
          vehicleName: false,
          year: false,
          make: false,
          model: false,
          plateNumber: false,
          insuranceExpDate: false,
          registrationExpDate: false,
          location: false,
          //Notes and Files Page Sort by feature
          createdOn: false,
          createdBy: false,
          category: false,
          description: false,
          fileName: false,
        };
    }
  }

  canStatusBeUpdated(previousStatus, currentStatus) {
    this.prevStatus = {
      isNotStarted: previousStatus == LegDetailStatus.notStarted,
      isEnroute: previousStatus == LegDetailStatus.enroute,
      isOnStandby: previousStatus == LegDetailStatus.onStandby,
      isRepositioning: previousStatus == LegDetailStatus.repositioning,
      isInPosition: previousStatus == LegDetailStatus.inPosition,
      isOnScene: previousStatus == LegDetailStatus.onScene,
      isOnBoard: previousStatus == LegDetailStatus.onBoard,
      isPickedUp: previousStatus == LegDetailStatus.pickedUp,
      isWheelsUp: previousStatus == LegDetailStatus.wheelsUp,
      isLanded: previousStatus == LegDetailStatus.landed,
      isDroppedOff: previousStatus == LegDetailStatus.droppedOff,
      isDriverDone: previousStatus == LegDetailStatus.driverDone,
      isJobDone: previousStatus == LegDetailStatus.jobDone,
    };

    this.currStatus = {
      isNotStarted: currentStatus == LegDetailStatus.notStarted,
      isEnroute: currentStatus == LegDetailStatus.enroute,
      isOnStandby: currentStatus == LegDetailStatus.onStandby,
      isRepositioning: currentStatus == LegDetailStatus.repositioning,
      isInPosition: currentStatus == LegDetailStatus.inPosition,
      isOnScene: currentStatus == LegDetailStatus.onScene,
      isOnBoard: currentStatus == LegDetailStatus.onBoard,
      isPickedUp: currentStatus == LegDetailStatus.pickedUp,
      isWheelsUp: currentStatus == LegDetailStatus.wheelsUp,
      isLanded: currentStatus == LegDetailStatus.landed,
      isDroppedOff: currentStatus == LegDetailStatus.droppedOff,
      isDriverDone: currentStatus == LegDetailStatus.driverDone,
      isJobDone: currentStatus == LegDetailStatus.jobDone,
    };

    switch (true) {
      case this.prevStatus.isEnroute && this.currStatus.isNotStarted:
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isOnScene && (this.currStatus.isEnroute || this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isPickedUp && (this.currStatus.isOnScene || this.currStatus.isEnroute || this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isDroppedOff &&
        (this.currStatus.isPickedUp || this.currStatus.isOnScene || this.currStatus.isEnroute || this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isDriverDone &&
        (this.currStatus.isDroppedOff ||
          this.currStatus.isPickedUp ||
          this.currStatus.isOnScene ||
          this.currStatus.isEnroute ||
          this.currStatus.isLanded ||
          this.currStatus.isWheelsUp ||
          this.currStatus.isOnBoard ||
          this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isOnBoard &&
        (this.currStatus.isInPosition || this.currStatus.isRepositioning || this.currStatus.isOnStandby || this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isWheelsUp &&
        (this.currStatus.isOnBoard ||
          this.currStatus.isInPosition ||
          this.currStatus.isRepositioning ||
          this.currStatus.isOnStandby ||
          this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isLanded &&
        (this.currStatus.isWheelsUp ||
          this.currStatus.isOnBoard ||
          this.currStatus.isInPosition ||
          this.currStatus.isRepositioning ||
          this.currStatus.isOnStandby ||
          this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      case this.prevStatus.isJobDone &&
        (this.currStatus.isDriverDone ||
          this.currStatus.isDroppedOff ||
          this.currStatus.isPickedUp ||
          this.currStatus.isOnScene ||
          this.currStatus.isEnroute ||
          this.currStatus.isLanded ||
          this.currStatus.isWheelsUp ||
          this.currStatus.isOnBoard ||
          this.currStatus.isInPosition ||
          this.currStatus.isRepositioning ||
          this.currStatus.isOnStandby ||
          this.currStatus.isNotStarted):
        this.isUpdateStatus = confirm(ConfirmationMsg.legStatusChange(previousStatus, currentStatus));
        break;
      default:
        this.isUpdateStatus = true;
    }
    return this.isUpdateStatus;
  }

  getSRStatus(legStatus: string): ISRStatusModel {
    if (legStatus != null) {
      const legStatusArray = legStatus.split(',');
      let statusMsg = '';

      switch (true) {
        case legStatusArray[0].toLowerCase() == LegDetailStatus.notStarted.toLowerCase():
          statusMsg = `Not started towards ${legStatusArray[1]}`;
          break;
        case legStatusArray[0] == LegDetailStatus.enroute || legStatusArray[0] == LegDetailStatus.onBoard:
          statusMsg = ` ${legStatusArray[0]} at ${legStatusArray[1]}`;
          break;
        case legStatusArray[0] == LegDetailStatus.onScene:
          statusMsg = `On-Scene at ${legStatusArray[1]}`;
          break;
        case legStatusArray[0] == LegDetailStatus.pickedUp || legStatusArray[0] == LegDetailStatus.wheelsUp:
          statusMsg = `${legStatusArray[0]} from ${legStatusArray[1]}`;
          break;
        case legStatusArray[0].toLowerCase() == LegDetailStatus.droppedOff.toLowerCase() || legStatusArray[0] == LegDetailStatus.landed:
          statusMsg = `${legStatusArray[0]} at ${legStatusArray[1]}`;
          break;
        case legStatusArray[0] == LegDetailStatus.inPosition:
          statusMsg = LegDetailStatus.inPosition;
          break;
        case legStatusArray[0] == LegDetailStatus.repositioning:
          statusMsg = LegDetailStatus.repositioning;
          break;
        case legStatusArray[0] == LegDetailStatus.onStandby:
          statusMsg = LegDetailStatus.onStandby;
          break;
        case legStatusArray[0] == LegDetailStatus.jobDone || legStatusArray[0] == LegDetailStatus.driverDone:
          statusMsg = '';
          break;
      }

      return {
        status: legStatusArray[0],
        direction: legStatusArray[2],
        description: statusMsg,
      };
    } else {
      return {
        status: '',
        direction: '',
        description: '',
      };
    }
  }
}
